import { useState } from 'react';
import { loadSession, type Session } from './api.js';
import { Login } from './Login.js';
import { Chat } from './Chat.js';

export function App() {
  const [session, setSession] = useState<Session | null>(() => loadSession());

  return session ? (
    <Chat session={session} onLogout={() => setSession(null)} />
  ) : (
    <Login onDone={setSession} />
  );
}
